import {CommonModule} from '@angular/common';

import {provideHttpClient, withInterceptorsFromDi} from '@angular/common/http';
import {importProvidersFrom} from '@angular/core';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {MatButtonModule} from '@angular/material/button';
import {MatInputModule} from '@angular/material/input';
import {bootstrapApplication, BrowserModule} from '@angular/platform-browser';
import {provideRouter} from '@angular/router';
import {FlexLayoutModule} from '@ngbracket/ngx-layout';
import {provideTranslateService} from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';
import {CommonsModule} from '@npck/libs/commons';
import {UiKitModule} from '@npck/libs/ui-kit';
import {provideNgxWebstorage, withLocalStorage, withSessionStorage} from 'ngx-webstorage';
import {appRoutes} from './app/app-routing.module';
import {AppComponent} from './app/root/app.component';

bootstrapApplication(AppComponent, {
    providers: [
        importProvidersFrom(
            CommonModule,
            CommonsModule,
            BrowserModule,
            FlexLayoutModule,
            MatButtonModule,
            MatInputModule,
            FormsModule,
            ReactiveFormsModule,
            UiKitModule
        ),
        provideHttpClient(withInterceptorsFromDi()),
        provideNgxWebstorage(withLocalStorage(), withSessionStorage()),
        provideTranslateService({
            loader: provideTranslateHttpLoader({
                prefix: '/assets/i18n/',
                suffix: '.json',
            }),
        }),
        provideRouter(appRoutes),
    ],
})
    .catch(err => console.error(err));
